// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCQpSignatureModelAttestation } from './tCQpSignatureModelAttestation.js';
import type { TCQpSignatureModelEnterpriseDBDocument } from './tCQpSignatureModelEnterpriseDBDocument.js';
import type { TCQpSignatureModelField } from './tCQpSignatureModelField.js';
import type { TCQpSignatureModelRecipient } from './tCQpSignatureModelRecipient.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Email Signature Template Request
*/
export class TCQpSignatureModelEmailSignatureTemplateRequest {
    /**
    * @description Program identifier
    */
    'programId': number;
    /**
    * @description Account identifier
    */
    'accountId'?: number | null;
    /**
    * @description Case identifier
    */
    'caseId'?: number | null;
    /**
    * @description Document Type
    */
    'documentType': string;
    /**
    * @description Brand identifier
    */
    'brandId': string;
    /**
    * @description Sender identifier
    */
    'senderId': string;
    /**
    * @description Template identifier
    */
    'templateId': string;
    /**
    * @description Expire In Days
    */
    'expireInDays'?: number | null;
    /**
    * @description Email Subject
    */
    'emailSubject': string;
    /**
    * @description Email Body
    */
    'emailBody': string;
    /**
    * @description Send
    */
    'send': boolean;
    /**
    * @description Embedded
    */
    'embedded': boolean;
    /**
    * @description Reply Email Address Override
    */
    'replyEmailAddressOverride'?: string | null;
    /**
    * @description External Party Code
    */
    'externalPartyCode'?: string | null;
    /**
    * @description External Program Code
    */
    'externalProgramCode'?: string | null;
    /**
    * @description Url of the website that a DocuSign document is generated from
    */
    'urlSource': string;
    /**
    * @description Recipients
    */
    'recipients': Array<TCQpSignatureModelRecipient>;
    /**
    * @description Fields
    */
    'fields': Array<TCQpSignatureModelField>;
    /**
    * @description Attestations
    */
    'attestations': Array<TCQpSignatureModelAttestation>;
    /**
    * @description Enterprise DB Documents
    */
    'enterpriseDBDocuments': Array<TCQpSignatureModelEnterpriseDBDocument>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelEmailSignatureTemplateRequest>> = [
        {
            "name":     "programId",
            "baseName": "programId",
            "type":     "number"
        },
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "caseId",
            "baseName": "caseId",
            "type":     "number"
        },
        {
            "name":     "documentType",
            "baseName": "documentType",
            "type":     "string"
        },
        {
            "name":     "brandId",
            "baseName": "brandId",
            "type":     "string"
        },
        {
            "name":     "senderId",
            "baseName": "senderId",
            "type":     "string"
        },
        {
            "name":     "templateId",
            "baseName": "templateId",
            "type":     "string"
        },
        {
            "name":     "expireInDays",
            "baseName": "expireInDays",
            "type":     "number"
        },
        {
            "name":     "emailSubject",
            "baseName": "emailSubject",
            "type":     "string"
        },
        {
            "name":     "emailBody",
            "baseName": "emailBody",
            "type":     "string"
        },
        {
            "name":     "send",
            "baseName": "send",
            "type":     "boolean"
        },
        {
            "name":     "embedded",
            "baseName": "embedded",
            "type":     "boolean"
        },
        {
            "name":     "replyEmailAddressOverride",
            "baseName": "replyEmailAddressOverride",
            "type":     "string"
        },
        {
            "name":     "externalPartyCode",
            "baseName": "externalPartyCode",
            "type":     "string"
        },
        {
            "name":     "externalProgramCode",
            "baseName": "externalProgramCode",
            "type":     "string"
        },
        {
            "name":     "urlSource",
            "baseName": "urlSource",
            "type":     "string"
        },
        {
            "name":     "recipients",
            "baseName": "recipients",
            "type":     "Array<TCQpSignatureModelRecipient>"
        },
        {
            "name":     "fields",
            "baseName": "fields",
            "type":     "Array<TCQpSignatureModelField>"
        },
        {
            "name":     "attestations",
            "baseName": "attestations",
            "type":     "Array<TCQpSignatureModelAttestation>"
        },
        {
            "name":     "enterpriseDBDocuments",
            "baseName": "enterpriseDBDocuments",
            "type":     "Array<TCQpSignatureModelEnterpriseDBDocument>"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelEmailSignatureTemplateRequest.attributeTypeMap;
    }
}
